<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.forms.tagName`),
      tagLink: `${searchResult.link}/forms`,
    }"
    class="form-card result-card"
  >
    <template #preview>
      <div class="preview-fallback">
        <Icon
          name="lucide:file-pen-line"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="`${searchResult.link}/forms/${searchResult.id}`"
        class="title"
        >{{ searchResult.name }}</a
      >
      <div
        v-if="searchResult.publish_date"
        class="dates-and-times"
      >
        <div class="published-at">{{ $t('search.forms.published') }}: {{ formattedDateAndTime }}</div>
        <div class="updated-at"></div>
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import { computed } from 'vue';
import { monthDayYear } from '../../../helpers/date-utils';

const props = defineProps({
  searchResult: {
    type: Object,
    default: () => ({}),
  },
});

const formattedDateAndTime = computed(() => {
  return monthDayYear(props.searchResult.publish_date) || '';
});
</script>

<style scoped>
.form-card {
  --color-green-200: #26aa80;
  --color-green-50: #f5fcfa;
  --background-color: var(--color-green-50);
  --text-color: var(--color-green-200);
}
</style>
